import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "main-content-container p-15 p-sm-20 p-md-25 p-lg-30" };
const _hoisted_2 = { class: "d-flex align-items-center justify-content-between mb-25" };
const _hoisted_3 = { "aria-label": "breadcrumb" };
const _hoisted_4 = { class: "breadcrumb mb-0" };
const _hoisted_5 = { class: "breadcrumb-item" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_router_link = _resolveComponent("router-link");
    const _component_UpsellSettings = _resolveComponent("UpsellSettings");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            _cache[3] || (_cache[3] = _createElementVNode("h3", { class: "mb-0 fw-bold text-black" }, "Recommandations", -1)),
            _createElementVNode("nav", _hoisted_3, [
                _createElementVNode("ol", _hoisted_4, [
                    _createElementVNode("li", _hoisted_5, [
                        _createVNode(_component_router_link, {
                            to: "/home",
                            class: "text-decoration-none"
                        }, {
                            default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                                    _createTextVNode("Tableau de bord", -1)
                                ]))]),
                            _: 1
                        })
                    ]),
                    _cache[1] || (_cache[1] = _createElementVNode("li", {
                        class: "breadcrumb-item active",
                        "aria-current": "page"
                    }, "Marketing", -1)),
                    _cache[2] || (_cache[2] = _createElementVNode("li", {
                        class: "breadcrumb-item active",
                        "aria-current": "page"
                    }, "Upsell", -1))
                ])
            ])
        ]),
        _createVNode(_component_UpsellSettings)
    ]));
}
